// TODO DIGDEV-3223 Remove this file when new Data SIM page is released
import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'styled-components'
import dsTheme from '../../constants/design-system/theme.json'

import { theme } from '../../constants/theme'

import withApp from '../../components/withApp/withApp'
import SEO from '../../components/Seo'
import TrustPilot from '../../components/TrustPilot'
import PlanSection from '../../components/PlanSection'
import TextLink from '../../components/TextLink'
import Button from '../../components/Button'

// Modular system components
import Hero from '../../modular-system/Hero'
import FaqSection from '../../modular-system/FaqSection'
import FiftyFifty from '../../modular-system/FiftyFifty'
import LogoGarden from '../../modular-system/LogoGarden'

// Global Styled Components
import CenteredButton from '../../components/styles/CenteredButton'
import FullWidthContainer from '../../components/styles/FullWidthContainer'
import SiteContainer from '../../components/styles/SiteContainer'
import Spacer from '../../components/styles/Spacer'

import HeroImage from '../../static/images/seo-landing-pages/no-credit-check-people.svg'
import DataImage from '../../static/images/seo-landing-pages/no-credit-check-data.svg'
import DataSimDevice from '../../static/images/seo-landing-pages/data-sim-device.svg'
import DataSimNoTies from '../../static/images/seo-landing-pages/data-sim-no-ties.svg'
import DataDiscount from '../../static/images/seo-landing-pages/data-sim-data-discount.svg'
import DataPlan from '../../static/images/seo-landing-pages/data-sim-data-plan.svg'
import UnlimitedImage from '../../static/images/seo-landing-pages/no-credit-check-unlimited.svg'
import { RICH_DATA_STRINGS } from '../../constants/globalStrings'

const { colors } = dsTheme

const DataSim = ({ plans: { plans } }) => (
  <>
    <SEO
      itemType={RICH_DATA_STRINGS.FAQ_ITEM_TYPE}
      title={dataSimContent.seo.title}
      description={dataSimContent.seo.description}
      keywords={dataSimContent.seo.keywords}
    />

    <FullWidthContainer background={colors['UI/DarkGrey']}>
      <SiteContainer>
        <Hero
          heading={dataSimContent.heading}
          benefits={dataSimContent.benefits}
          CTA={dataSimContent.heroCta}
          imageUrl={HeroImage}
          imageAlt={dataSimContent.heroImageAlt}
          CTALink={dataSimContent.CTALink}
        />
      </SiteContainer>
    </FullWidthContainer>

    <SiteContainer>
      <LogoGarden
        css={css`
          margin-left: 0;
          margin-right: 0;
        `}
      />
    </SiteContainer>

    <SiteContainer
      style={{
        backgroundColor: colors['UI/DarkGrey'],
      }}
    >
      <FiftyFifty imageTextSmall inverse>
        <img src={dataSimContent.heroImgSrc} alt="" />
        {dataSimContent.heroContent}
      </FiftyFifty>
    </SiteContainer>

    <SiteContainer>
      {dataSimContent.imageTextSections.slice(0, 2).map((fiftyFifty, index) => (
        <>
          <FiftyFifty
            index={index}
            imageTextSmall
            inverse={Math.abs(index % 2) === 1}
          >
            <img src={fiftyFifty.imageSrc} alt="" />
            {fiftyFifty.content}
          </FiftyFifty>
        </>
      ))}
    </SiteContainer>

    <SiteContainer
      data-module-id={plans.length > 0 ? 'plan-modules-data-sim' : null}
      data-module_name="simple-plans"
      data-module_placement="products-section"
    >
      <PlanSection plans={plans} />
    </SiteContainer>

    <SiteContainer>
      {dataSimContent.imageTextSections.slice(2, 6).map((fiftyFifty, index) => (
        <>
          <FiftyFifty
            index={index}
            imageTextSmall
            inverse={Math.abs(index % 2) === 1}
          >
            <img src={fiftyFifty.imageSrc} alt="" />
            {fiftyFifty.content}
          </FiftyFifty>
        </>
      ))}
    </SiteContainer>

    <FullWidthContainer background={colors['UI/DarkGrey']}>
      <SiteContainer>
        <TrustPilot
          dataTags="SelectedReview"
          dataTestId="homepage-trustpilot-widget"
        />
      </SiteContainer>
    </FullWidthContainer>

    <SiteContainer>
      <Spacer />
      <FaqSection faqAccordions={dataSimContent.faqAccordions} />
      <Spacer />
    </SiteContainer>

    <SiteContainer>
      <CenteredButton>
        <Button
          href={dataSimContent.CTALink}
          color={theme.colors.button.buttonColor}
        >
          {dataSimContent.heroCta}
        </Button>
      </CenteredButton>
    </SiteContainer>
    <Spacer />
  </>
)

const dataSimContent = {
  heading: 'Data SIM deals that work for tablets and mobile broadband too',
  benefits: [
    'Unrestricted tethering in the UK',
    'No speed restrictions',
    'No credit checks',
  ],
  heroContent: (
    <>
      <h2 className="kollektif-extra-large">
        Looking for a SIM-only data plan?
      </h2>
      <p className="margin--regular">
        Choose one of our 1GB, 2GB or 3GB Data Discount plans and get money back
        for what you don’t use. But if you need loads of data, you’ll get
        equally amazing value with our 30GB, 50GB and{' '}
        <TextLink to="plans/unlimited">Unlimited data plans</TextLink>.
      </p>
    </>
  ),
  heroImgSrc: DataPlan,
  heroImageAlt: 'Data SIM plans',
  heroCta: 'View our plans',
  CTALink: '#plans',
  seo: {
    title: 'Compare our Tablet & Mobile Broadband SIM deals',
    description:
      'Switch to a simple SIM-only data plan. Perfect for tablets, dongles, Wi-Fi routers and other mobile devices. (uSwitch “Best Value SIM Only” Winner 2020)',
    keywords: ['Data SIM', 'Tablet SIM', 'MBB SIM', 'Mobile broadband SIM'],
  },
  faqAccordions: [
    {
      faqId: 'data-only-sim-card',
      faqTitle: 'Can I get a data-only SIM card?',
      faqTitleTestId: 'data-only-sim-card-title',
      faqContent:
        'Data-only SIM cards are perfect if you’ve got a tablet with SIM capability and you want to get online wherever you are. You can purchase a SMARTY SIM with varying levels of data – from just 1GB to Unlimited. Plus, you can even get money back on what you don’t use when you pick one of our Data Discount plans. While our SIMs are not technically data-only they are still compatible  with tablets and mobile broadband devices. Unlimited calls and texts come as standard on all of our SMARTY SIMs, but you won’t pay extra for them and you don’t have to use them.',
      faqContentTestId: 'data-only-sim-card-content',
    },

    {
      faqId: 'data-get-sim-card-tablet',
      faqTitle: 'Can I get a SIM card for my tablet?',
      faqTitleTestId: 'data-get-sim-card-tablet-title',
      faqContent:
        'While every tablet on the market is likely to be Wi-Fi enabled, not all tablets let you insert a SIM card for 3G or 4G internet access. If your tablet does support SIM cards, then a SMARTY SIM is perfect for getting online. Our flexible plans offer anything from 1GB to Unlimited data and can be amended as and when you need them.',
      faqContentTestId: 'get-sim-card-tablet-content',
    },
    {
      faqId: 'data-20gb-enough-month',
      faqTitle: 'Is 20GB enough for a month?',
      faqTitleTestId: 'data-20gb-enough-for-month-title',
      faqContent:
        ' Most people are more than happy on 20GB of data a month. For that amount you can spend around 2 hours a day browsing the web and social media, 2 hours listening to music and one hour streaming your favourite shows. To put it into perspective, a 2019 study by OFCOM showed that the average person used 2.9GB of mobile data per month, and while that’s naturally expected to increase, 20GB shouldn’t leave you in much danger of running out. If you are worried though, SMARTY offer great value 30GB, 50GB and Unlimited data SIMs.',
      faqContentTestId: '20gb-enough-for-month-content',
    },
    {
      faqId: 'unlimited-data-mobile-broadband',
      faqTitle: 'Can I get unlimited data for mobile broadband?',
      faqTitleTestId: 'unlimited-data-mobile-broadband-title',
      faqContent:
        'Yes, you can. At SMARTY, all of our SIMs are compatible with mobile broadband devices. That means on our Unlimited SIM plan you can get unlimited 4G and 3G data with no speed restrictions and unlimited UK tethering. Plus, it’s a flexible one-month contract with no credit check.',
      faqContentTestId: 'unlimited-data-content',
    },
  ],
  imageTextSections: [
    {
      imageSrc: DataSimDevice,
      content: (
        <>
          <h2 className="kollektif-extra-large">
            Switch to a simple SIM-only data plan
          </h2>
          <p className="margin--regular">
            Perfect as a tablet SIM, Mobile broadband SIM or in dongles and
            other mobile devices.
          </p>
          <p className="margin--regular">
            We’re SMARTY - the SIM-only mobile network that’s all about keeping
            things simple. All plans come with unlimited calls and texts,
            unrestricted tethering in the UK, no speed restrictions,{' '}
            <TextLink to="/no-credit-check-sim">no credit check</TextLink> and a
            1 month plan you can cancel any time.
          </p>
        </>
      ),
    },
    {
      imageSrc: DataDiscount,
      content: (
        <>
          <h2 className="kollektif-extra-large">Only pay for what you use</h2>
          <p className="margin--none">
            Whatever monthly data discount plan you&apos;re on, you get credit
            for any data you don&apos;t use. We reckon this makes us one of the
            best deals around for Mobile and MBB SIM contracts.
          </p>
        </>
      ),
    },
    {
      imageSrc: DataSimNoTies,
      content: (
        <>
          <h2 className="kollektif-extra-large">No long contracts, no ties</h2>
          <p className="margin--none">
            Simply pay for your first month up front, then on a rolling monthly
            basis. You’re free to pause or cancel at any time – no commitment,
            no hassle. Unlike some{' '}
            <TextLink to="/sim-only">SIM contracts</TextLink>, you’re not tied
            in and there’s no surprise charges. Oh, and there’s no need for a
            credit check.
          </p>
        </>
      ),
    },
    {
      imageSrc: DataImage,
      content: (
        <>
          <h2 className="kollektif-extra-large">
            Don’t get stung for extra data
          </h2>
          <p className="margin--regular">Extra data at only £1 per GB</p>
          <p className="margin--regular">
            All data discount plans are capped, so you’ll never accidentally
            overspend if you run out of data. But if you find you need any
            extra, it’s super easy to add more at a rate of £1 per GB.
          </p>
          <p className="margin--regular">
            Data add-ons also never expire. As long as you have a live, current
            SIM plan, it stays there. Forever. And ever.
          </p>
        </>
      ),
    },
    {
      imageSrc: UnlimitedImage,
      content: (
        <>
          <h2 className="kollektif-extra-large">
            Unlimited UK standard texts and calls
          </h2>
          <p className="margin--none">
            Our SIMs are also ideal for phones. Each plan comes with unlimited
            UK standard texts and calls included, and you don’t have to change
            your number when switching.
          </p>
        </>
      ),
    },
  ],
}

DataSim.propTypes = {
  plans: {
    plans: PropTypes.array.isRequired,
  },
}

export default withApp(DataSim)
